<template>
  <div>
    <div id="colors-tab" class="w-full h-full">
      <div class="flex p-1">
        <VPill text="all" @click="setScreenSize('all')" :selected="screenSize === 'all'" />
        <VPill text="sm" @click="setScreenSize('sm')" :selected="screenSize === 'sm'" />
        <VPill text="md" @click="setScreenSize('md')" :selected="screenSize === 'md'" />
        <VPill text="lg" @click="setScreenSize('lg')" :selected="screenSize === 'lg'" />
        <VPill text="xl" @click="setScreenSize('xl')" :selected="screenSize === 'xl'" />
      </div>

      <div class="flex p-1">
        <VPill text="normal" @click="setStyleMode('normal')" :selected="styleMode === 'normal'" />
        <VPill text="hover" @click="setStyleMode('hover')" :selected="styleMode === 'hover'" />
        <VPill text="focus" @click="setStyleMode('focus')" :selected="styleMode === 'focus'" />
        <VPill text="active" @click="setStyleMode('active')" :selected="styleMode === 'active'" />
      </div>

      <div class="p-1">
        <VTabs :tabs="mainTabs.tabs" :isGrow="true" @change="(item)=> mainTabs.select(item) " />
      </div>
      <div id="tabs-content" class="px-1 pt-1 overflow-y-auto" style="height:75vh">
        <div v-for="(item,i) in getLayout()" :key="i">
          <VClassPanel :list="item.value" v-if="mainTabs.isSelected(item.key)" />
        </div>
        <div class="pt-1">
          <div v-if="mainTabs.isSelected('Bg')">
            <div class="w-full bg-gray-900 py-2">
              <div
                class="flex flex-wrap justify-center m-auto overflow-auto"
                style="height:34vh; width:32vh"
              >
                <div
                  v-for="(item, i) of images"
                  :key="i"
                  class="items-center flex-grow mt-2"
                  @click="applyImage(item)"
                >
                  <img :src="item.thumb" class="h-16 w-16 object-cover" />
                </div>
              </div>
            </div>
            <VClassPanel :list="getBackground()" />
          </div>

          <div v-if="mainTabs.isSelected('Custom')">
            <div class="text-center text-gray-100 font-bold">Gradients</div>
            <div class="flex justify-center">
              <VStyleButton
                v-for="(item,i) of gradients"
                :key="i"
                :className="item.name"
                type="shadow"
                class="mr-1"
                :selected="isClassSelected(item.name)"
                @click.native="addClass(item.name)"
              />
            </div>
            <div class="text-center text-gray-100 font-bold">Shadows</div>
            <div class="flex justify-center">
              <VStyleButton
                v-for="(item,i) of shadows"
                :key="i"
                :className="item.name"
                type="shadow"
                class="mr-1"
                :selected="isClassSelected(item.name)"
                @click.native="addClass(item.name)"
              />
            </div>
            <div class="text-center text-gray-100 font-bold">Border Radius</div>
            <div class="flex justify-center">
              <VStyleButton
                v-for="(item,i) of borderRadiuses"
                :key="i"
                :className="item.name"
                type="borderRadius"
                class="mr-1"
                :selected="isClassSelected(item.name)"
                @click.native="addClass(item.name)"
              />
            </div>
          </div>

          <VColorPanel v-if="mainTabs.isSelected('Colors')" :colors="getColors()" />
          <VClassPanel v-if="mainTabs.isSelected('Text')" :list="getText()" />
          <VClassPanel v-if="mainTabs.isSelected('Border')" :list="getBorder()" />
          <VClassPanel v-if="mainTabs.isSelected('Shadow')" :list="getShadow()" />

          <VClassPanel v-if="mainTabs.isSelected('Rounded')" :list="rounded" />

          <VClassPanel v-if="mainTabs.isSelected('Transition')" :list="transition[0].value" />
          <VClassPanel v-if="mainTabs.isSelected('Position')" :list="position" />
          <VClassPanel v-if="mainTabs.isSelected('Opacity')" :list="opacity" />
          <VGridPanel  v-if="mainTabs.isSelected('Grid')"  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { UiTabs } from "../util";
export default {
  name: "PropertyManager",
  props: {
    msg: String
  },
  data() {
    return {
      mainTabs: new UiTabs([
        "Colors",
        "Bg",
        "Text",
        "Border",
        "Rounded",

        "Flex",
        "Width",
        "Height",
        "Margin",
        "Padding",

        "Position",
        "Shadow",
        "Opacity",
        "Transition",
        "Custom",
        "Grid"
      ])
    };
  },
  mounted() {},
  computed: {
    ...mapGetters([
      "rootNode",
      "cssStyles",
      "selectedItemClassList",
      "tailwind",
      "bg",
      "text",
      "flex",
      "border",
      "width",
      "height",
      "margin",
      "padding",
      "shadow",
      "position",
      "opacity",
      "rounded",
      "background",
      "transition",
      "styleMode",
      "isClassSelected",
      "images",
      "fonts",
      "screenSize"
    ]),
    ...mapState(["gradients", "shadows", "borderRadiuses"])
  },
  methods: {
    ...mapActions([
      "addClass",
      "editItem",
      "setStyleMode",
      "setScreenSize",
      "applyImage"
    ]),
    getDesign() {
      return {
        Shadow: this.shadow,
        Rounded: this.rounded
      };
    },
    getShadow() {
      return [{ key: "Shadow", value: this.shadow }];
    },
    getBackground() {
      return [
        {
          key: "Bg",
          value: this.background.filter(item => !item.hasNumber())
        }
      ];
    },
    getBorder() {
      return [
        {
          key: "Border",
          value: this.border.filter(item => !item.hasNumber())
        }
      ];
    },
    getColors() {
      return [
        {
          key: "Background",
          value: this.background.filter(item => item.hasNumber()),
          type: "bg"
        },
        {
          key: "Text",
          value:
            this.text && this.text.text
              ? this.text.text.filter(item => item.hasNumber())
              : [],
          type: "text"
        },
        {
          key: "Border",
          value: this.border.filter(item => item.hasNumber()),
          type: "border"
        }
      ];
    },
    getText() {
      return [
        {
          key: "Text",
          value:
            this.text && this.text.text
              ? this.text.text.filter(item => !item.hasNumber())
              : []
        },
        { key: "Fonts", value: this.text.fonts },
        { key: "Fonts Family", value: this.text.fontsFamily }
      ];
    },
    getLayout() {
      const list = [
        { key: "Flex", value: this.flex },
        {
          key: "Width",
          value: this.width
        },
        {
          key: "Height",
          value: this.height
        },
        { key: "Margin", value: this.margin },
        { key: "Padding", value: this.padding }
      ];
      return list;
    },
    onMainTabsChange(item) {
      this.mainTabs.select(item);
      if (item === "Design") {
        this.mainTabs.select("Bg");
      } else if (item === "Layout") {
        this.mainTabs.select("Flex");
      }
    },
    getCustom() {
      return [
        {
          key: "Gradients",
          value: this.gradients.map(item => item.name),
          type: "bg"
        },
        {
          key: "Shadows",
          value: this.shadows.map(item => item.name),
          type: "shadow"
        }
      ];
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
}

.grid-4 > div {
  /* border: 1px solid gray; */
  min-height: 4rem;
}
</style>
